import React from "react";
import qs from "qs";
import FormCambista from "../_Components/FormCambista";
import MasterTemplate from "./MasterTemplate";
import { Link } from 'react-router-dom';



export class MasterCadastroCambista extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        super(props);
        this.state = {
            user: JSON.parse(localStorage.getItem("user")),
        }
        this.queryString = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
    }

    render() {
        const tutorId = '';
        const { id } = this.queryString

        return (
            <MasterTemplate label="Cadastrar Cambista">
                <div className="content">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-md-12 col-lg-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h4 className="card-title">Cadastro de Cambista</h4>
                                    </div>
                                    <div className="card-body">
                                        <FormCambista perfil="CAMBISTA" history={this.props.history} tutorId={this.state.user._id} id={id} redirect={'master-gerencia-cambistas'} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MasterTemplate>
        );
    }
}

export default MasterCadastroCambista;
